// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"hq-z","slideIn":"iq-z"};